import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  subjectFragment,
  unitTypeFragment,
  staffFragment,
  commentNodeFragment,
  notificationFragment,
  resourceLibraryFragment,
  attachmentNodeFragment,
  pypElementFragment,
  focusAreaFragment,
  organizationPypElementSetFragment,
  plannerTemplateFragment,
  criteriaSetFragment,
  criteriaSetSlimFragment,
  criteriaValueFragment,
  studentFragment,
  parentFragment,
  gradeFragment,
  academicYearFragment,
  courseFragment,
  organizationCoursesFragment,
  coachMarkFragment,
  notificationListNodeFragment,
  attachmentGroupsNodeFragment,
  messageFragment,
  plannerElementNodeFragment,
  attachmentFragment,
  genericTagFragment,
} from "./CommonFragments";
import {
  getPlannerElementSetsOfCurriculumQuery,
  getPlannerElementNodesOfSetQuery,
  getOrganizationCurriculumProgramsQuery,
  getAtlSetQuery,
  getBenchmarkSetQuery,
  getPypRelatedConceptSetQuery,
  getPlannerTemplateQuery,
  getOrganizationConstantsQuery,
  getOrganizationDetailsQuery,
  getAssessmentToolNodeDetailsQuery,
  getCommentOfNodeQuery,
  getOrganizationGradeBasicDetailsQuery,
  getGlobalConstantsQuery,
  getHelpTextQuery,
  getPlatformUserDetailsQuery,
  getChildrenQuery,
  getSubjectBenchmarksQuery,
  getATLsQuery,
  getNotificationsQuery,
  getCurriculumAttendanceOptionsQuery,
  getOrganizationMultiCurriculumAttendanceOptionsQuery,
  getSubjectsByGradeQuery,
  getOrganizationSubjectGroupsQuery,
  getOrganizationBasicCoursesQuery,
  getOrganizationSubjectsQuery,
  getOrganizationSubjectsQueryV2,
  getAcademicCriteriaSetsQuery,
  getOrganizationElementRatingQuery,
  getOrganizationPeriodSetsQuery,
  getPypAtlConstantsQuery,
  getPlannerElementNodesOfSetWithDepthLabelQuery,
  getAttachmentQuery,
  getOrganizationStudentListQuery,
  getOrganizationGradesQuery,
  getStaffListQuery,
  getOrganizationStaffQuery,
  getFilteredPostCountWithTypeQuery,
  getUserGradesQuery,
  getOrganizationGlobalConstantsQuery,
  getUserDetailsWithLinkedIdentitiesQuery,
  getOrganizationSubjectsWithPlannerElementDepthLabelSetsQuery,
  getPlannerElementSetNodesAndDepthLabelsQuery,
  getFilteredTags,
  getStudentPeriodListQuery,
  getUserPeriodListQuery,
  getStudentPeriodListInfoQuery,
  getOrganizationYearGroupsQuery,
  getOrganizationExamSessionsQuery,
  getDpSubjectVariantsQuery,
  getOrganizationYearGroupIdsQuery,
  getOrganizationMultiLevelNodeTagsQuery,
  getOrganizationTemplatesQuery,
  getIbOfferedSubjectVariants,
  getOrganizationTemplatesWithHelpEnabledFieldsQuery,
  getStudentStaffRelationQuery,
  getYearGroupAssociatedChildPlannerElementNodesQuery,
  getPypPlannerElementNodesOfCurriculumQuery,
  getOrganizationSubjectsBasicDetailsQuery,
  getAcademicYearTermsQuery,
  getPypPlannerThemeSetNodesQuery,
  getOrganizationGlobalGenericTagsQuery,
  getAllOrganizationFeedQuery,
  getOrganizationPeriodSetQuery,
  getAssessmentToolsDetailsByStudentAssignmentIdQuery,
  getDpSubjectVariantsQueryV2,
  getTemplateFieldPropertiesQuery,
  getOrganizationYearGroupsNameQuery,
  getBenchmarkSetOfCurriculumQuery,
  getAIConversationsQuery,
  getAIPromptsQuery,
  getAIPromptSetsQuery,
  getAssessmentToolsDetailsByPostIdQuery,
  getUbdAssessmentTypesQuery,
  getPlatformStaffIdentityDetailsQuery,
  getAiConversationsQuery,
  getAIConversationsQueryWithPublicUrl,
  getAssessmentGradesQuery,
} from "./CommonQuery";
import { configurationItemFragment } from "ChildrenPage/modules/ChildrenPageFragments";
import { rubricFragment } from "Rubric/modules/RubricFragments";
import { checklistFragment } from "Checklist/modules/ChecklistFragments";
import { singlePointRubricFragment } from "SinglePointRubric/modules/SinglePointRubricFragments";
import { assessmentToolFragment } from "modules/AssessmentTool/AssessmentToolFragment";
import { standardRubricFragment } from "AppComponents/StandardRubric/modules/StandardRubricFragments";
import { gradeScaleToolFragment } from "AppComponents/AssessmentGradeScaleTool/modules/AssessmentGradeScaleToolFragments";

export const generateConfigurationUid = ({ entityGroups, configName }) => {
  const entityGroupsParsed = _.map(
    entityGroups,
    ({ entityType, entityId }) => `${entityType}::${entityId}`
  );
  return _.concat(entityGroupsParsed, [configName]).join("::");
};

const fragmentNameMapping = {
  PLANNER_FIELD: {
    typeName: "PlannerField",
    fragment: "plannerField",
    fragmentName: "plannerFieldNodeItem",
  },
  EXEMPLAR: {
    typeName: "Exemplar",
    fragment: "exemplar",
    fragmentName: "exemplarNodeItem",
  },
  UNIT_PLAN: {
    typeName: "UnitPlan",
    fragment: "unitPlan",
    fragmentName: "unitPlanNodeItem",
  },
  ASSESSMENT: {
    typeName: "Assessment",
    fragment: "assessment",
    fragmentName: "assessmentNodeItem",
  },
  LEARNING_ENGAGEMENT: {
    typeName: "LearningEngagement",
    fragment: "le",
    fragmentName: "leNodeItem",
  },
  POST: {
    typeName: "Post",
    fragment: "post",
    fragmentName: "postItem",
  },
  ATL: {
    typeName: "PlannerATL",
    fragment: "atl",
    fragmentName: "atlItem",
  },
  MYP_ATL: {
    typeName: "PlannerATL",
    fragment: "atl",
    fragmentName: "atlItem",
  },
  LEARNER_PROFILE: {
    typeName: "PlannerLearnerProfile",
    fragment: "lp",
    fragmentName: "lpItem",
  },
  DP_LEARNER_PROFILE: {
    typeName: "PlannerElementNode",
    fragment: "plannerElementNode",
    fragmentName: "plannerElementNode",
  },
  DP_SUBJECT: {
    typeName: "PlannerElementNode",
    fragment: "plannerElementNode",
    fragmentName: "plannerElementNode",
  },
  CONCEPT: {
    typeName: "PlannerConcept",
    fragment: "concept",
    fragmentName: "conceptItem",
  },
  ACTION: {
    typeName: "Action",
    fragment: "action",
    fragmentName: "actionItem",
  },
  THEME: {
    typeName: "PlannerTheme",
    fragment: "theme",
    fragmentName: "themeItem",
  },
  BENCHMARK: {
    typeName: "PlannerBenchmark",
    fragment: "benchmark",
    fragmentName: "benchmarkItem",
  },
  RELATED_CONCEPT: {
    typeName: "PlannerRelatedConcept",
    fragment: "relatedConcept",
    fragmentName: "relatedConceptItem",
  },
  STUDENT_GOAL_TASK: {
    typeName: "GoalTask",
    fragment: "studentGoalTask",
    fragmentName: "studentGoalTaskItem",
  },
  COMMUNITY_UNIT_PLAN: {
    typeName: "UnitPlan",
    fragment: "communityUnitPlan",
    fragmentName: "communityUnitPlanItem",
  },
  COMMUNITY_ASSESSMENT: {
    typeName: "Assessment",
    fragment: "communityAssessment",
    fragmentName: "communityAssessmentItem",
  },
  PROJECT_SIGNATURE_STUDENT: {
    typeName: "Student",
    fragment: "studentSignature",
    fragmentName: "studentSignature",
  },
  PROJECT_SIGNATURE_SUPERVISOR: {
    typeName: "Staff",
    fragment: "supervisorSignature",
    fragmentName: "supervisorSignature",
  },
  PLANNER_ELEMENT_NODE: {
    typeName: "PlannerElementNode",
    fragment: "plannerElementNode",
    fragmentName: "plannerElementNode",
  },
  ENTITY_PLANNER_ELEMENT_NODE_MAP: {
    typeName: "EntityPlannerElementNodeMap",
    fragment: "EntityPlannerElementNodeMap",
    fragmentName: "EntityPlannerElementNodeMap",
  },
  QUESTION_ATTACHMENT: {
    typeName: "QuestionAttachment",
    fragment: "questionFieldAttachment",
    fragmentName: "questionFieldAttachment",
  },
  QUESTION_SUBMISSION_ATTACHMENT: {
    typeName: "QuestionAttachment",
    fragment: "questionFieldAttachment",
    fragmentName: "questionFieldAttachment",
  },
  PROJECT_EVIDENCE: {
    typeName: "Project",
    fragment: "projectComments",
    fragmentName: "projectCommentItem",
  },
  INCIDENT_DETAIL: {
    typeName: "BehaviourIncident",
    fragment: "incidentDetail",
    fragmentName: "incidentDetail",
  },
  INCIDENT_CONFIDENTIAL_DETAIL: {
    typeName: "BehaviourIncident",
    fragment: "incidentConfidentialDetail",
    fragmentName: "incidentConfidentialDetail",
  },
  CIRCULAR: {
    typeName: "Circular",
    fragment: "circularDetailsAttachment",
    fragmentName: "circularDetailsAttachment",
  },
  PROJECT_TASK: {
    typeName: "Project",
    fragment: "projectComments",
    fragmentName: "projectCommentItem",
  },
  PROJECT_PRESENTATION: {
    typeName: "Project",
    fragment: "projectComments",
    fragmentName: "projectCommentItem",
  },
};

const pypElementSetFragmentNameMapping = {
  BENCHMARK: {
    fragment: "benchmarkSet",
  },
  RELATED_CONCEPT: {
    fragment: "relatedConceptSet",
  },
  CONCEPT: {
    fragment: "conceptSet",
  },
  LEARNER_PROFILE: {
    fragment: "lpSet",
  },
  ATL: {
    fragment: "atlSet",
  },
  THEME: {
    fragment: "themeSet",
  },
  ACTION: {
    fragment: "actionSet",
  },
};

const assessmentToolFragmentNameMapping = {
  RUBRIC: {
    typeName: "Rubric",
    fragment: rubricFragment.rubric,
    fragmentName: "rubricItem",
  },
  CHECKLIST: {
    typeName: "Checklist",
    fragment: checklistFragment.checklist,
    fragmentName: "checklist",
  },
  SINGLE_POINT_RUBRIC: {
    typeName: "SinglePointRubric",
    fragment: singlePointRubricFragment.singlePointRubric,
    fragmentName: "singlePointRubricItem",
  },
  ANECDOTE: {
    typeName: "Anecdote",
    fragment: assessmentToolFragment.anecdote,
    fragmentName: "anecdoteItem",
  },
  EXEMPLAR: {
    typeName: "Exemplar",
    fragment: assessmentToolFragment.exemplar,
    fragmentName: "exemplarItem",
  },
  MYP_OBJECTIVE_RUBRIC: {
    typeName: "MypObjectiveRubric",
    fragment: assessmentToolFragment.mypObjectiveRubric,
    fragmentName: "mypObjectiveRubricItem",
  },
  MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC: {
    typeName: "MypObjectiveRubric",
    fragment: assessmentToolFragment.mypObjectiveRubric,
    fragmentName: "mypObjectiveRubricItem",
  },
  SCORE_BASED_RUBRIC: {
    typeName: "StandardRubric",
    fragment: standardRubricFragment.standardRubric,
    fragmentName: "standardRubricItem",
  },
  STANDARD_BASED_RUBRIC: {
    typeName: "StandardRubric",
    fragment: standardRubricFragment.standardRubric,
    fragmentName: "standardRubricItem",
  },
  GRADE_SCALE_TOOL: {
    type: "GradeScaleEntityDetail",
    fragment: gradeScaleToolFragment.gradeScaleEntityDetails,
    fragmentName: "gradeScaleEntityDetailsItem",
  },
};

const userBasicDetailsFragmentMap = {
  STAFF: {
    typeName: "Staff",
    fragment: staffFragment["basicStaffDetails"],
    fragmentName: "staffItem",
  },
  STUDENT: {
    typeName: "Student",
    fragment: studentFragment["basicStudentDetails"],
    fragmentName: "studentItem",
  },
  FAMILY_MEMBER: {
    typeName: "FamilyMember",
    fragment: parentFragment["basicParentDetails"],
    fragmentName: "parentItem",
  },
};

const userNotificationCountFragmentMap = {
  STAFF: {
    typeName: "Staff",
    fragment: notificationFragment["staffCountItem"],
    fragmentName: "staffCountItem",
  },
  STUDENT: {
    typeName: "Student",
    fragment: notificationFragment["studentCountItem"],
    fragmentName: "studentCountItem",
  },
  FAMILY_MEMBER: {
    typeName: "FamilyMember",
    fragment: notificationFragment["parentCountItem"],
    fragmentName: "parentCountItem",
  },
};

const userNotificationListFragmentMap = {
  STAFF: {
    typeName: "Staff",
    fragment: notificationListNodeFragment["staff"],
    fragmentName: "staffItem",
  },
  STUDENT: {
    typeName: "Student",
    fragment: notificationListNodeFragment["student"],
    fragmentName: "studentItem",
  },
  FAMILY_MEMBER: {
    typeName: "FamilyMember",
    fragment: notificationListNodeFragment["parent"],
    fragmentName: "parentItem",
  },
};

export const attachmentGroupsNodeFragmentMap = {
  STUDENT_ASSIGNMENT_SUBMISSION: {
    typeName: "StudentAssignmentSubmission",
    fragment:
      attachmentGroupsNodeFragment[
        "studentAssignmentSubmissionAttachmentGroups"
      ],
    fragmentName: "studentAssignmentSubmissionAttachmentGroupsItem",
  },
  PLANNER_FIELD_STUDENT_TEMPLATE: {
    typeName: "ResolvedFieldStudentTemplate",
    fragment: attachmentGroupsNodeFragment["studentTemplateAttachmentGroups"],
    fragmentName: "studentTemplateAttachmentGroupsItem",
  },
  PLANNER_FIELD_LTI_TEMPLATE: {
    typeName: "ResolvedFieldLtiTemplate",
    fragment: attachmentGroupsNodeFragment["ltiTemplateAttachmentGroups"],
    fragmentName: "ltiTemplateAttachmentGroupsItem",
  },
  PLANNER_FIELD_OPENING_MESSAGE_RESOURCE: {
    typeName: "ResolvedFieldOpeningMessageResource",
    fragment:
      attachmentGroupsNodeFragment["openingMessageResourcesAttachmentGroups"],
    fragmentName: "openingMessageResourcesAttachmentGroupsItem",
  },
};

export const getDpSubjectVariantsFromCache = variables => {
  try {
    const result = client.readQuery({
      query: getDpSubjectVariantsQuery,
      variables,
    });
    return result || {};
  } catch (e) {
    return {};
  }
};

export const getDpSubjectVariantsFromCacheV2 = variables => {
  try {
    const result = client.readQuery({
      query: getDpSubjectVariantsQueryV2,
      variables,
    });
    return result || {};
  } catch (e) {
    return {};
  }
};

export const getIbOfferedSubjectVariantsFromCache = ({
  subjectVariantFilters,
  subjectGroupFilters,
  globalTagFilters,
}) => {
  try {
    const queryData = client.readQuery({
      query: getIbOfferedSubjectVariants,
      variables: {
        subjectVariantFilters,
        subjectGroupFilters,
        globalTagFilters,
      },
    });
    return queryData || {};
  } catch (e) {
    return {};
  }
};

export const getPlatformUserDetailsFromCache = ({ id, type }) => {
  try {
    const queryData = client.readQuery({
      query: getPlatformUserDetailsQuery,
      variables: {
        id,
        type,
      },
    });

    return _.get(queryData, "node") || {};
  } catch (e) {
    return {};
  }
};

export const getPlatformStaffIdentityDetailsFromCache = ({ id, type }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getPlatformStaffIdentityDetailsQuery,
      variables: {
        id,
        type,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, `node`, {});
  else return {};
};

export const getUserDetailsWithLinkedIdentitiesFromCache = ({
  id,
  type,
  first,
  after,
  searchText,
}) => {
  let queryData;
  try {
    queryData = client.readQuery({
      query: getUserDetailsWithLinkedIdentitiesQuery,
      variables: { id, type, first, after, searchText },
    });
  } catch (e) {
    return {};
  }
  return queryData?.node ?? {};
};

export const getOrganizationStudentListFromCache = ({
  searchText,
  grades,
  courses,
  organizationId,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationStudentListQuery,
      variables: { searchText, grades, courses, organizationId },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, `node`, {});
  else return {};
};

export const getChildrenFromCache = ({
  id,
  type,
  organizationId,
  teacherId,
  includeInvitedStudents,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getChildrenQuery,
      variables: {
        id,
        type,
        organizationId,
        teacherId,
        includeInvitedStudents,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, `node`, {});
  else return {};
};

export const getAcademicYearDetailsFromCahce = id => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `AcademicYear:${id}`,
      fragment: academicYearFragment.academicYear,
      fragmentName: "academicYearItem",
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getGlobalConstantsFromCache = () => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getGlobalConstantsQuery,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) {
    return _.get(queryData, "globalConstants", {});
  } else return {};
};

export const getPlannerTemplateFromCache = (
  variables,
  returnAsArray = false
) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getPlannerTemplateQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) {
    const templates = _.get(queryData, "multiNode", []);
    if (templates.length == 1 && !returnAsArray) {
      return templates[0];
    } else {
      return templates;
    }
  } else return {};
};

export const getPlannerTemplateFromFragment = templateId => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `PlannerTemplate:${templateId}`,
      fragment: plannerTemplateFragment.plannerTemplate,
      fragmentName: "templateItem",
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getPypElementFromCache = ({ type, id }) => {
  let queryData = {};
  try {
    const typeName = fragmentNameMapping[type].typeName;
    const fragment = fragmentNameMapping[type].fragment;
    const fragmentName = fragmentNameMapping[type].fragmentName;

    queryData = client.readFragment({
      id: `${typeName}:${id}`,
      fragment: pypElementFragment[fragment],
      fragmentName: fragmentName,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getPlannerElementNodeFromCache = ({ id }) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `PlannerElementNode:${id}`,
      fragment: plannerElementNodeFragment.plannerElementNode,
      fragmentName: "plannerElementNodeItem",
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const writePlannerElementInCache = ({ id, data }) => {
  try {
    client.writeFragment({
      id: `PlannerElementNode:${id}`,
      fragmentName: "plannerElementNodeItem",
      fragment: plannerElementNodeFragment.plannerElementNode,
      data,
    });
  } catch (e) {
    return {};
  }
};
export const writePypElementFromCache = ({ type, id, data }) => {
  try {
    const typeName = fragmentNameMapping[type].typeName;
    const fragment = fragmentNameMapping[type].fragment;
    const fragmentName = fragmentNameMapping[type].fragmentName;

    client.writeFragment({
      id: `${typeName}:${id}`,
      fragment: pypElementFragment[fragment],
      fragmentName: fragmentName,
      data: data,
    });
  } catch (e) {
    return {};
  }
};

export const getFocusAreaFromCache = id => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `FocusArea:${id}`,
      fragment: focusAreaFragment.focusArea,
      fragmentName: "focusAreaItem",
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const writeOrganizationPypElementSetInCache = ({
  subjects,
  grades,
  organizationId,
  type,
  data,
}) => {
  const fragment = pypElementSetFragmentNameMapping[type].fragment;

  try {
    client.writeFragment({
      id: `Organization:${organizationId}`,
      fragment: organizationPypElementSetFragment[fragment],
      fragmentName: "organizationPypElementSetItem",
      data: data,
      variables: {
        subjects,
        grades,
      },
    });
  } catch (err) {
    return {};
  }
};

export const getOrganizationPypElementSetFromCache = ({
  subjects,
  grades,
  organizationId,
  type,
  concepts,
  genericTagIds,
  unitPlanIds,
}) => {
  let queryData = {};
  let query;

  try {
    switch (type) {
      case "BENCHMARK":
        query = getBenchmarkSetQuery;
        break;
      case "ATL":
        query = getAtlSetQuery;
        break;
      case "RELATED_CONCEPT":
        query = getPypRelatedConceptSetQuery;
        break;
    }
    queryData = client.readQuery({
      query,
      variables: {
        subjects,
        grades,
        organizationId,
        type,
        concepts,
        genericTagIds,
        unitPlanIds,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", "");
  else return {};
};

export const getPypRelatedConceptSetFromCache = ({
  subjects,
  concepts,
  curriculumId,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getPypRelatedConceptSetQuery,
      variables: {
        subjects,
        concepts,
        curriculumId,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", "");
  else return {};
};

export const getOrganizationGlobalGenericTagsFromCache = ({
  globalTagFilters,
}) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getOrganizationGlobalGenericTagsQuery,
      variables: {
        globalTagFilters,
      },
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "globalConstants.globalGenericTags", []);
};

export const getAllOrganizationFeedFromCache = ({ filters }) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getAllOrganizationFeedQuery,
      variables: {
        filters,
      },
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "platform.allOrganizationFeed", []);
};

export const getOrganizationCurriculumProgramsFromCache = organizationId => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationCurriculumProgramsQuery,
      variables: {
        organizationId,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getPlannerElementNodesOfSetFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getPlannerElementNodesOfSetQuery,
      variables: {
        id,
        filters,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getPlannerElementNodesOfSetWithDepthLabelFromCache = ({
  id,
  filters,
  plannerElementDepthLabelSetFilters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getPlannerElementNodesOfSetWithDepthLabelQuery,
      variables: {
        id,
        filters,
        plannerElementDepthLabelSetFilters,
      },
    });
  } catch (e) {
    return {};
  }
  return queryData !== null ? _.get(queryData, "node", {}) : {};
};

export const writePlannerElementNodesOfSetInCache = ({ id, filters, data }) => {
  let queryData = {};
  try {
    queryData = client.writeQuery({
      query: getPlannerElementNodesOfSetQuery,
      variables: {
        id,
        filters,
      },
      data,
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getPlannerElementSetsOfCurriculumFromCache = ({
  id,
  elementTypes,
  type,
  filters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getPlannerElementSetsOfCurriculumQuery,
      variables: {
        id,
        elementTypes,
        type,
        filters,
      },
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getYearGroupAssociatedChildPlannerElementNodesFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getYearGroupAssociatedChildPlannerElementNodesQuery,
      variables: params,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getOrganizationConstantsFromCache = organizationId => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationConstantsQuery,
      variables: {
        id: organizationId,
      },
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node.constants", {});
};

export const getCriteriaSetDetailsFromCache = id => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `AcademicCriteriaSet:${id}`,
      fragment: criteriaSetFragment.criteriaSet,
      fragmentName: "criteriaSetItem",
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getCriteriaSetSlimDetailsFromCache = id => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `AcademicCriteriaSet:${id}`,
      fragment: criteriaSetSlimFragment.criteriaSetSlim,
      fragmentName: "criteriaSetSlimItem",
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const writeCriteriaSetInCache = ({ id, data }) => {
  let queryData = {};
  try {
    queryData = client.writeFragment({
      id: `AcademicCriteriaSet:${id}`,
      fragment: criteriaSetFragment.criteriaSet,
      fragmentName: "criteriaSetItem",
      data,
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getCriteriaValueFromCache = id => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `AcademicCriteriaValue:${id}`,
      fragment: criteriaValueFragment.criteriaValue,
      fragmentName: "criteriaValueItem",
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getOrganizationDetailsFromCache = organizationId => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationDetailsQuery,
      variables: {
        id: organizationId,
      },
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getOrganizationPeriodSetsFromCache = (
  organizationId,
  periodSetFilter
) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationPeriodSetsQuery,
      variables: {
        id: organizationId,
        periodSetFilter,
      },
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getOrganizationPeriodSetFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationPeriodSetQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getGradeBasicDetailsFromCache = id => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Grade:${id}`,
      fragment: gradeFragment.basicGradeDetails,
      fragmentName: "gradeItem",
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getOrganizationBasicGradeDetailsFromCache = ({
  organizationId,
  filters,
}) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getOrganizationGradeBasicDetailsQuery,
      variables: {
        organizationId,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getAcademicYearTermsFromCache = ({ academicYearId, filters }) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getAcademicYearTermsQuery,
      variables: {
        academicYearId,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getOrganizationAllCoursesFromCache = ({
  organizationId,
  filters,
}) => {
  let queryData = {};

  try {
    queryData = client.readFragment({
      id: `Organization:${organizationId}`,
      fragment: organizationCoursesFragment.organizationCourses,
      fragmentName: "organizationCourseItem",
      variables: {
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getUserBasicDetailsFromCache = ({ id, type }) => {
  let queryData = {};

  try {
    const { typeName, fragment, fragmentName } = userBasicDetailsFragmentMap[
      type
    ];
    queryData = client.readFragment({
      id: `${typeName}:${id}`,
      fragment,
      fragmentName,
    });
  } catch (e) {
    return {};
  }

  return queryData ? queryData : {};
};

export const writeUserBasicDetailsFromCache = ({ id, data, type }) => {
  let queryData = {};
  const { typeName, fragment, fragmentName } = userBasicDetailsFragmentMap[
    type
  ];
  try {
    queryData = client.writeFragment({
      id: `${typeName}:${id}`,
      fragment,
      fragmentName,
      data,
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getStaffBasicDetailsFromCache = user_id => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Staff:${user_id}`,
      fragment: staffFragment.basicStaffDetails,
      fragmentName: "staffItem",
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getStudentBasicDetailsFromCache = user_id => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Student:${user_id}`,
      fragment: studentFragment.basicStudentDetails,
      fragmentName: "studentItem",
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getSubjectBasicDetailsFromCache = subject_id => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Subject:${subject_id}`,
      fragment: subjectFragment.basicSubjectDetails,
      fragmentName: "subjectItem",
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getUnitTypeFromCache = type_id => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `UnitType:${type_id}`,
      fragment: unitTypeFragment.unitType,
      fragmentName: "unitTypeItem",
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getResourceFeedItemFromCache = ({ resource_id, type }) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `${fragmentNameMapping[type].typeName}:${resource_id}`,
      fragment: resourceLibraryFragment.resourceFeed,
      fragmentName: "resourceLibraryItem",
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getCommentsOfNodeFromCache = ({
  nodeId,
  type,
  isCommunity,
  commentFilters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCommentOfNodeQuery,
      variables: {
        id: nodeId,
        type,
        isCommunity,
        commentFilters: commentFilters || undefined,
      },
    });
  } catch (e) {
    console.warn({ e });
    return {};
  }
  return _.get(queryData, "node", {});
};

export const writeCommentNodeFragment = ({
  nodeId,
  data,
  type,
  parentType,
  commentFilters,
  isCommunity = false,
}) => {
  const fragmentObj =
    fragmentNameMapping[parentType] || fragmentNameMapping[type] || {};
  const typeName = fragmentObj.typeName;
  const fragment = fragmentObj.fragment;
  const fragmentName = fragmentObj.fragmentName;
  try {
    client.writeFragment({
      id: `${typeName}:${nodeId}`,
      fragment: commentNodeFragment[fragment],
      fragmentName: fragmentName,
      data: data,
      variables: commentFilters
        ? {
            id: nodeId,
            type: type,
            commentFilters: commentFilters,
            isCommunity,
          }
        : undefined,
    });
  } catch (e) {
    console.warn("Error writing comment node fragment:", e);
    return {};
  }
};

export const writeMessageFragment = ({ nodeId, data }) => {
  try {
    client.writeFragment({
      id: `Message:${nodeId}`,
      fragment: messageFragment.message,
      fragmentName: "messageItem",
      data: data,
    });
  } catch (e) {
    return {};
  }
};

export const readMessageFragment = ({ id }) => {
  let queryData = {};

  queryData = client.readFragment({
    id: `Message:${id}`,
    fragment: messageFragment.message,
    fragmentName: "messageItem",
  });

  return queryData ? queryData : {};
};

export const getAttachmentOfNodeFromCache = ({ nodeId, type }) => {
  let queryData = {};
  try {
    const typeName = fragmentNameMapping[type].typeName;
    const fragment = fragmentNameMapping[type].fragment;
    const fragmentName = fragmentNameMapping[type].fragmentName;
    queryData = client.readFragment({
      id: `${typeName}:${nodeId}`,
      fragment: attachmentNodeFragment[fragment],
      fragmentName: fragmentName,
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getAttachmentGroupsOfNodeFromCache = ({ id, type }) => {
  let queryData = {};
  const { typeName, fragment, fragmentName } =
    attachmentGroupsNodeFragmentMap[type] || {};

  try {
    queryData = client.readFragment({
      id: `${typeName}:${id}`,
      fragment,
      fragmentName,
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const writeAttachmentNodeFragment = ({ nodeId, data, type }) => {
  const typeName = fragmentNameMapping[type]?.typeName;
  const fragment = fragmentNameMapping[type]?.fragment;
  const fragmentName = fragmentNameMapping[type]?.fragmentName;
  if (!typeName || !fragment || !fragmentName) {
    return;
  }
  try {
    client.writeFragment({
      id: `${typeName}:${nodeId}`,
      fragment: attachmentNodeFragment[fragment],
      fragmentName: fragmentName,
      data: data,
    });
  } catch (e) {}
};

export const writeAttachmentGroupsOfNodeInCache = ({ id, type, data }) => {
  let queryData = {};
  const { typeName, fragment, fragmentName } =
    attachmentGroupsNodeFragmentMap[type] || {};

  try {
    queryData = client.writeFragment({
      id: `${typeName}:${id}`,
      fragment,
      fragmentName,
      data,
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const writeNotificationFragment = ({ notificationId, data }) => {
  client.writeFragment({
    id: `Notification:${notificationId}`,
    fragment: notificationFragment.notificationItem,
    fragmentName: "notificationItem",
    data,
  });
};

export const getNotificationFromCache = notificationId => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Notification:${notificationId}`,
      fragment: notificationFragment.notificationItem,
      fragmentName: "notificationItem",
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getNotificationListFromCache = ({
  id,
  type,
  notificationCategoryFilter,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getNotificationsQuery,
      variables: {
        id,
        type,
        notificationCategoryFilter,
      },
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

// export const getStaffNotificationItemFromCache = ({
//   staffId,
//   notificationCategoryFilter
// }) => {
//   let queryData = {};
//   try {
//     queryData = client.readFragment({
//       id: `Staff:${staffId}`,
//       fragment: staffFragment.staffNotificationItem,
//       fragmentName: "staffItem",
//       variables: { notificationCategoryFilter }
//     });
//   } catch (e) {
//     // console.log(e);
//     return {};
//   }
//   if (queryData != null) return queryData;
//   else return {};
// };

export const writeNotificationListInCache = ({
  id,
  type,
  data,
  notificationCategoryFilter,
}) => {
  const { typeName, fragment, fragmentName } = userNotificationListFragmentMap[
    type
  ];

  try {
    client.writeFragment({
      id: `${typeName}:${id}`,
      fragment,
      fragmentName,
      variables: {
        notificationCategoryFilter,
      },
      data,
    });
  } catch (e) {
    return {};
  }
};

// export const getStaffNotificationCountFromCache = staffId => {
//   let queryData = {};
//   try {
//     queryData = client.readFragment({
//       id: `Staff:${staffId}`,
//       fragment: notificationFragment.staffCountItem,
//       fragmentName: "staffCountItem"
//     });
//   } catch (e) {
//     return {};
//   }
//   if (queryData != null) return queryData;
//   else return {};
// };

export const getUserNotificationCountFromCache = ({
  id,
  type,
  notificationCategoryFilter,
}) => {
  let queryData = {};
  const { typeName, fragment, fragmentName } = _.get(
    userNotificationCountFragmentMap,
    type,
    {}
  );

  try {
    queryData = client.readFragment({
      id: `${typeName}:${id}`,
      fragment,
      fragmentName,
      variables: {
        notificationCategoryFilter,
      },
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getBasicCourseDetailFromCache = courseId => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Course:${courseId}`,
      fragment: courseFragment.basicCourserDetails,
      fragmentName: "courseItem",
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const geCourseGradesDetailFromCache = courseId => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Course:${courseId}`,
      fragment: courseFragment.courseGradeSubjectDetails,
      fragmentName: "courseGradeSubjectItem",
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

// export const writeStaffNotificationCountFromCache = ({ staffId, data }) => {
//   try {
//     client.writeFragment({
//       id: `Staff:${staffId}`,
//       fragment: notificationFragment.staffCountItem,
//       fragmentName: "staffCountItem",
//       data
//     });
//   } catch (e) {
//     console.log(e);
//   }
// };

export const writeUserNotificationInFromCache = ({
  id,
  data,
  type,
  notificationCategoryFilter,
}) => {
  const { typeName, fragment, fragmentName } = _.get(
    userNotificationCountFragmentMap,
    type,
    {}
  );
  try {
    client.writeFragment({
      id: `${typeName}:${id}`,
      fragment,
      fragmentName,
      data,
      variables: {
        notificationCategoryFilter,
      },
    });
  } catch (e) {
    return {};
  }
};

export const getCurriculumAttendanceOptionsQueryFromCache = ({
  id,
  curriculumId,
  filter,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCurriculumAttendanceOptionsQuery,
      variables: {
        id,
        curriculumId,
        filter,
      },
    });
  } catch (e) {
    return {};
  }

  return queryData ? queryData : {};
};

export const getOrganizationMultiCurriculumAttendanceOptionsQueryFromCache = ({
  id,
  filter,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationMultiCurriculumAttendanceOptionsQuery,
      variables: {
        id,
        filter,
      },
    });
  } catch (e) {
    return {};
  }

  return queryData ? queryData : {};
};

export const getHelpTextFromCache = ({ id, locale }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getHelpTextQuery,
      variables: {
        id,
        locale,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "planner.i18nHelpText", {});
  else return {};
};

export const getAssessmentToolNodeDetailsFromCache = ({ id, type }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getAssessmentToolNodeDetailsQuery,
      variables: {
        id,
        type,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeAssessmentToolNodeDetailsInCache = ({ id, type, data }) => {
  const typeName = assessmentToolFragmentNameMapping[type].typeName;
  const fragment = assessmentToolFragmentNameMapping[type].fragment;
  const fragmentName = assessmentToolFragmentNameMapping[type].fragmentName;
  let queryData = {};
  try {
    queryData = client.writeFragment({
      id: `${typeName}:${id}`,
      fragment,
      fragmentName,
      data,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return queryData;
  else return {};
};

export const getAssessmentToolNodeDetailsFromCacheV2 = ({ id, type }) => {
  const typeName = assessmentToolFragmentNameMapping[type].typeName;
  const fragment = assessmentToolFragmentNameMapping[type].fragment;
  const fragmentName = assessmentToolFragmentNameMapping[type].fragmentName;
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `${typeName}:${id}`,
      fragment,
      fragmentName,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return queryData;
  else return {};
};

export const getStaffCoachMarksFromCache = userId => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Staff:${userId}`,
      fragment: staffFragment.staffCoachMarks,
      fragmentName: "staffCoachMarksItem",
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getStudentCoachMarksFromCache = userId => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Student:${userId}`,
      fragment: studentFragment.studentCoachMarks,
      fragmentName: "studentCoachMarksItem",
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getCoachMarkStatusFromCache = coachMarkId => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `CoachMarkUserStatus:${coachMarkId}`,
      fragment: coachMarkFragment.coachMark,
      fragmentName: "coachMarkItem",
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const writeCoachMarkStatusInCache = ({ coachMarkId, data }) => {
  let queryData = {};
  try {
    queryData = client.writeFragment({
      id: `CoachMarkUserStatus:${coachMarkId}`,
      fragment: coachMarkFragment.coachMark,
      fragmentName: "coachMarkItem",
      data,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getGradeUnitDetailsFromCache = ({
  gradeId,
  userId,
  isCurriculumProgramFree,
}) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Grade:${gradeId}`,
      fragment: gradeFragment.gradeUnitDetails,
      fragmentName: "gradeItem",
      variables: {
        id: userId,
        isCurriculumProgramFree,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const writeGradeUnitDetailsInCache = ({
  id,
  data,
  userId,
  isCurriculumProgramFree,
}) => {
  try {
    client.writeFragment({
      id: `Grade:${id}`,
      fragment: gradeFragment.gradeUnitDetails,
      fragmentName: "gradeItem",
      variables: {
        id: userId,
        isCurriculumProgramFree,
      },
      data,
    });
  } catch (e) {}
};

export const getSubjectBenchmarksFromCache = ({ subject, grades }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getSubjectBenchmarksQuery,
      variables: {
        subject,
        grades,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getATLsFromCache = ({ id, grades }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getATLsQuery,
      variables: {
        id,
        grades,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getSubjectsByGradeFromCache = ({ id }) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getSubjectsByGradeQuery,
      variables: { id },
    });
  } catch (e) {
    console.warn(e);
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getOrganizationSubjectGroupsFromCache = ({
  id,
  filters,
  subjectFilters,
}) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getOrganizationSubjectGroupsQuery,
      variables: { id, filters, subjectFilters },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeSubjectInCache = ({ subjectId, data }) => {
  try {
    client.writeFragment({
      id: `Subject:${subjectId}`,
      fragment: subjectFragment.subjectDetails,
      fragmentName: "subjectItem",
      data: data,
    });
  } catch (e) {}
};

export const getSubjectFromCache = ({ subjectId }) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Subject:${subjectId}`,
      fragment: subjectFragment.subjectDetails,
      fragmentName: "subjectItem",
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getOrganizationBasicCoursesFromCache = ({
  filters,
  organizationId,
}) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getOrganizationBasicCoursesQuery,
      variables: { filters, organizationId },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getOrganizationSubjectsFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationSubjectsQuery,
      variables: {
        id,
        filters,
      },
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getOrganizationSubjectsV2FromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationSubjectsQueryV2,
      variables,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getAcademicCriteriaSetsFromCache = ({
  organizationId,
  filters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getAcademicCriteriaSetsQuery,
      variables: { organizationId, filters },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeAcademicCriteriaSetsToCache = ({
  organizationId,
  filters,
  data,
}) => {
  let queryData = {};
  try {
    queryData = client.writeQuery({
      query: getAcademicCriteriaSetsQuery,
      variables: {
        organizationId,
        filters,
      },
      data,
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getOrganizationElementRatingFromCache = ({
  organizationId,
  filters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationElementRatingQuery,
      variables: {
        organizationId,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (!queryData) {
    return {};
  }
  return queryData;
};

export const writeOrganizationElementRatingToCache = ({
  organizationId,
  filters,
  data,
}) => {
  let queryData = {};
  try {
    queryData = client.writeQuery({
      query: getOrganizationElementRatingQuery,
      variables: {
        organizationId,
        filters,
      },
      data,
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getPypAtlConstantsFromCache = ({ pypAtlSetId, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getPypAtlConstantsQuery,
      variables: {
        pypAtlSetId,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getAttachmentFromCache = input => {
  let queryData;
  try {
    queryData = client.readQuery({
      query: getAttachmentQuery,
      variables: { ...input },
    });
  } catch (e) {
    return {};
  }
  return queryData ? _.get(queryData, "node", {}) : {};
};

export const getOrganizationGradesFromCache = ({ id, filters }) => {
  let queryData;
  try {
    queryData = client.readQuery({
      query: getOrganizationGradesQuery,
      variables: { id, filters },
    });
  } catch (e) {
    return {};
  }
  return queryData ? _.get(queryData, "node", {}) : {};
};

export const getStaffListFromCache = ({
  organizationId,
  searchText,
  grades,
  archivalState,
  courses,
  curriculumProgramIds,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStaffListQuery,
      variables: {
        organizationId,
        searchText,
        grades,
        archivalState,
        courses,
        curriculumProgramIds,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getOrganizationStaffFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationStaffQuery,
      variables: params,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getUserGradesFromCache = ({
  id: userId,
  type: userType,
  allGradesFilters,
}) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getUserGradesQuery,
      variables: {
        id: userId,
        type: userType,
        allGradesFilters,
      },
    });
  } catch (e) {
    return {};
  }
  return queryData != null ? queryData : {};
};

export const getOrganizationGlobalConstantsFromCache = ({
  organizationId,
  filter,
  filters,
}) => {
  let queryData = {};

  try {
    queryData = client.readQuery(
      {
        query: getOrganizationGlobalConstantsQuery,
        variables: {
          organizationId,
          filter: filter || filters,
        },
      },
      true
    );
  } catch (e) {
    return {};
  }

  return queryData != null ? queryData : {};
};

export const getFilteredPostCountWithTypeFromCache = ({
  id,
  filters,
  type,
}) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getFilteredPostCountWithTypeQuery,
      variables: {
        id,
        filters,
        type,
      },
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "node", {});
};

export const getAttachmentFragmentFromCache = ({ attachmentId }) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Attachment:${attachmentId}`,
      fragment: attachmentFragment.attachment,
      fragmentName: "attachmentItem",
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const writeAttachmentSimilarityReportInCache = ({
  attachmentId,
  data,
}) => {
  try {
    client.writeFragment({
      id: `Attachment:${attachmentId}`,
      fragment: attachmentFragment.attachment,
      fragmentName: "attachmentItem",
      data,
    });
  } catch (e) {
    return {};
  }
};

export const getOrganizationSubjectsWithPlannerElementDepthLabelSetsFromCache = ({
  id,
  subjectFilters,
  plannerDepthFilters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationSubjectsWithPlannerElementDepthLabelSetsQuery,
      variables: {
        id,
        subjectFilters,
        plannerDepthFilters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData !== null) return _.get(queryData, "node", {});
  return {};
};

export const getPlannerElementSetNodesAndDepthLabelsFromCache = ({
  id,
  filters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getPlannerElementSetNodesAndDepthLabelsQuery,
      variables: {
        id,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData !== null) return _.get(queryData, "node", {});
  return {};
};

export const getFilteredTagsFromCache = ({ keys }) => {
  let queryData = null;
  try {
    queryData = client.readQuery({
      query: getFilteredTags,
      variables: {
        keys,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData !== null) return queryData;
  return {};
};

export const getStudentPeriodListFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStudentPeriodListQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getUserPeriodListFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getUserPeriodListQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getPypPlannerThemeSetNodesFromCache = ({ variables }) => {
  try {
    const queryData = client.readQuery({
      query: getPypPlannerThemeSetNodesQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getStudentPeriodListInfoFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStudentPeriodListInfoQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getOrganizationYearGroupsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationYearGroupsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  if (queryData !== null) return queryData;
  return {};
};

export const getOrganizationYearGroupsNameFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationYearGroupsNameQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  if (queryData !== null) return queryData;
  return {};
};

export const getOrganizationYearGroupIdsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationYearGroupIdsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  if (queryData !== null) return queryData;
  return {};
};

export const getOrganizationExamSessionsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationExamSessionsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  if (queryData !== null) return queryData;
  return {};
};

export const getOrganizationMultiLevelNodeTagsFromCache = ({
  organizationId,
  nodeType,
  filters = {},
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationMultiLevelNodeTagsQuery,
      variables: {
        organizationId,
        nodeType,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeOrganizationMultiLevelNodeTagsToCache = ({
  variables,
  data,
}) => {
  try {
    client.writeQuery({
      query: getOrganizationMultiLevelNodeTagsQuery,
      variables,
      data,
    });
  } catch (e) {
    console.warn(e);
  }
};

// writing tag fragment to cache
export const writeOrganizationMultiLevelNodeTagToCache = ({ id, data }) => {
  try {
    client.writeFragment({
      id: `GenericTag:${id}`,
      fragmentName: "genericTagDetailsItem",
      fragment: genericTagFragment.genericTagDetails,
      data,
    });
  } catch (e) {
    console.error(e);
  }
};

// reading tag fragment from cache
export const getOrganizationMultiLevelNodeTagFromCache = ({ id }) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `GenericTag:${id}`,
      fragment: genericTagFragment.genericTagDetails,
      fragmentName: "genericTagDetailsItem",
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getOrganizationTemplatesFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationTemplatesQuery,
      variables: {
        id,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getOrganizationTemplatesWithHelpEnabledFieldsFromCache = ({
  id,
  filters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationTemplatesWithHelpEnabledFieldsQuery,
      variables: {
        id,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getStudentStaffRelationFromCache = ({ id, filters }) => {
  try {
    const queryData = client.readQuery({
      query: getStudentStaffRelationQuery,
      variables: {
        id,
        filters,
      },
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getPypPlannerElementNodesFromCache = ({ variables }) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getPypPlannerElementNodesOfCurriculumQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getOrganizationSubjectsBasicDetailsFromCache = ({
  id,
  filters,
}) => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationSubjectsBasicDetailsQuery,
      variables: {
        id,
        filters,
      },
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getAssessmentToolsDetailsByStudentAssignmentIdFromCache = ({
  id,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getAssessmentToolsDetailsByStudentAssignmentIdQuery,
      variables: {
        id,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getAssessmentToolsDetailsByPostIdFromCache = ({ id }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getAssessmentToolsDetailsByPostIdQuery,
      variables: {
        id,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getTemplateFieldPropertiesFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getTemplateFieldPropertiesQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "node", {});
};

export const getBenchmarkSetOfCurriculumFromCache = ({
  grades,
  curriculumId,
  type,
  subjects,
  unitPlanIds,
  genericTagIds,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getBenchmarkSetOfCurriculumQuery,
      variables: {
        grades,
        curriculumId,
        type,
        subjects,
        unitPlanIds,
        genericTagIds,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null)
    return _.get(queryData, "node.plannerElementSets[0]", {});
  else return {};
};

export const getAIConversationsFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getAIConversationsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "node", {});
};

export const getAIConversationsQueryWithPublicUrlFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getAIConversationsQueryWithPublicUrl,
      variables,
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "node", {});
};

export const writeAIConversationsQueryWithPublicUrlInCache = ({
  variables,
  data,
}) => {
  try {
    client.writeQuery({
      query: getAIConversationsQueryWithPublicUrl,
      variables,
      data: { node: data },
    });
  } catch (e) {
    return {};
  }
};

export const getAIPromptsFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getAIPromptsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "ai", {});
};

export const getAiConversationsFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getAiConversationsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "ai", {});
};

export const getAIPromptSetsFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getAIPromptSetsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "ai", {});
};

export const writeAIConversationsInCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getAIConversationsQuery,
      variables,
      data,
    });
  } catch (e) {
    return {};
  }
};

export const getUbdAssessmentTypesFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getUbdAssessmentTypesQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getChildAcademicYearsFromCache = variables => {
  return client.readFragment({
    id: `AcademicYear:${variables.id}`,
    fragment: academicYearFragment.academicYearChildAcademicYearDetails,
    fragmentName: "academicYearChildAcademicYearDetailsItem",
  });
};

export const readConfigurationFragmentV2 = (
  configurationVariables,
  configName
) => {
  try {
    const entityGroups = _.get(
      configurationVariables,
      "configurationEntityGroupFilters.0.configurationEntityGroups"
    );
    const id = generateConfigurationUid({ entityGroups, configName });
    const result = client.readFragment({
      id,
      fragment: configurationItemFragment.configurationItem,
      fragmentName: "configurationV2Item",
    });
    return result;
  } catch (error) {
    return {};
  }
};

export const getAssessmentGradesFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getAssessmentGradesQuery,
      variables,
    });

    return _.get(queryData, "node", {});
  } catch {
    return {};
  }
};
